/**
 * 资源是否已打赏
 */
export async function fetchIfResIsReward(
  resourceId: number,
  resourceType: number
) {
  if (!useUserInfo().value.login) {
    return { is_reward: false }
  }
  return http
    .get<{
      is_reward: boolean
    }>('/v1/reward/is_reward', {
      id: resourceId,
      type: resourceType
    })
    .then((res) => res.data)
}
